/**
 * Extract error message from API error response
 * Handles both string messages and Pydantic validation error arrays
 */
export const getErrorMessage = (error, fallbackMessage = 'Si è verificato un errore') => {
  // Check if error.response exists
  if (!error.response?.data) {
    return fallbackMessage;
  }

  const { detail } = error.response.data;

  // If detail is a string, return it
  if (typeof detail === 'string') {
    return detail;
  }

  // If detail is an array (Pydantic validation errors)
  if (Array.isArray(detail)) {
    // Extract messages from validation errors
    const messages = detail.map(err => {
      if (typeof err === 'string') return err;
      if (err.msg) return `${err.loc?.join('.')} - ${err.msg}`;
      return JSON.stringify(err);
    });
    return messages.join(', ');
  }

  // If detail is an object
  if (typeof detail === 'object') {
    return detail.message || detail.msg || JSON.stringify(detail);
  }

  return fallbackMessage;
};
